import React from 'react';

import PropTypes from 'prop-types';

import './BulletList.scss';

export const BulletList = ({ title, items }) => {
  return (
    <div className="bullet-list">
      <p className="bullet-list__title">{title}</p>
      <ul>{items}</ul>
    </div>
  );
};

BulletList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};
